import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to top on route change. Preserves scroll on hash-links. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
